import { render, staticRenderFns } from "./riskRuleList.vue?vue&type=template&id=17395f43&scoped=true&"
import script from "./riskRuleList.vue?vue&type=script&lang=js&"
export * from "./riskRuleList.vue?vue&type=script&lang=js&"
import style0 from "./riskRuleList.vue?vue&type=style&index=0&id=17395f43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17395f43",
  null
  
)

export default component.exports